import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Home from '@/components/home'
import Settings from '@/components/settings'
import Quizzes from '@/components/quizzes/quizzes'
import QuizzesList from '@/components/quizzes/list'
import QuizzesShow from '@/components/quizzes/show'
import QuizzesCreate from '@/components/quizzes/create'
import QuizzesReponses from '@/components/quizzes/responses'
import QuizzesPreconizations from '@/components/quizzes/preconizations'
import QuizzesPreconizationsCreateAction from '@/components/quizzes/preconizations/new_action'
import QuizzesPreconizationsShowActions from '@/components/quizzes/preconizations/show_actions'
import QuizzesExportPdf from '@/components/quizzes/export_pdf'
import Users from '@/components/users/users'
import UsersList from '@/components/users/list'
import UsersShow from '@/components/users/show'
import UsersCreate from '@/components/users/create'
import Compare from '@/components/compare/compare'
Vue.use(Router)

// mode 'history' permet d'enlever le # dans les routes. Ex: #!/login
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/accueil',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/parametres',
      name: 'settings',
      component: Settings,
      meta: { requiresAuth: true }
    },
    {
      path: '/compare',
      name: 'compare',
      component: Compare,
      meta: { requiresAuth: true }
    },
    {
      component: Quizzes,
      name: 'quizzes',
      path: '/questionnaire',
      children: [
          {
              path: '',
              component: QuizzesList,
              name: 'quizzes_list',
              breadcrumbs: 'Liste des questionnaires',
              meta: { requiresAuth: true }
          },
          {
              path: 'nouveau',
              component: QuizzesCreate,
              name: 'quizzes_create',
              breadcrumbs: 'Créer un questionnaire',
              meta: { requiresAuth: true }
          },
          {
              path: ':slug/edition',
              component: QuizzesCreate,
              name: 'quizzes_edit',
              breadcrumbs: 'Modifier un questionnaire',
              meta: { requiresAuth: true }
          },
          {
              path: ':slug',
              component: QuizzesShow,
              name: 'quizzes_show',
              breadcrumbs: 'Fiche d\'un questionnaire'
          },
          {
              path: ':slug/reponses',
              component: QuizzesReponses,
              name: 'quizzes_responses',
              breadcrumbs: 'Réponses au questionnaire',
              meta: { requiresAuth: true }
          },
          {
              path: ':slug/preconisations',
              component: QuizzesPreconizations,
              name: 'quizzes_preconizations',
              breadcrumbs: 'Préconisations du questionnaire',
              meta: { requiresAuth: true }
          },
          {
              path: ':slug/preconisations/nouvelle',
              component: QuizzesPreconizationsCreateAction,
              name: 'quizzes_preconizations_create_action',
              breadcrumbs: 'Création d\'une nouvelle action de préconisation',
              meta: { requiresAuth: true }
          },
          {
              path: ':slug/preconisations/:id',
              component: QuizzesPreconizationsCreateAction,
              name: 'quizzes_preconizations_edit_action',
              breadcrumbs: 'Edition d\'une action de préconisation',
              meta: { requiresAuth: true }
          },
          {
            path: ':slug/preconisations/actions/details',
            component: QuizzesPreconizationsShowActions,
            name: 'quizzes_preconizations_show_actions',
            breadcrumbs: 'Liste des actions d\'une préconisation',
            meta: { requiresAuth: true }
          },
          {
            path: ':slug/exportPDF',
            name:'quizzes_export_pdf',
            component: QuizzesExportPdf,
            breadcrumbs:"Export pdf du questionnaire",
            meta: { requiresAuth: true }
          }
      ]
    },
    {
      component: Users,
      name: 'users',
      path: '/utilisateurs',
      children: [
          {
              path: '',
              component: UsersList,
              name: 'users_list',
              breadcrumbs: 'Liste des utilisateurs',
              meta: { requiresAuth: true }
          },
          {
              path: 'nouveau',
              component: UsersCreate,
              name: 'users_create',
              breadcrumbs: 'Créer un utilisateur',
              meta: { requiresAuth: true }
          },
          {
              path: ':id/edition',
              component: UsersCreate,
              name: 'users_edit',
              breadcrumbs: 'Modifier un utilisateur',
              meta: { requiresAuth: true }
          },
          {
              path: ':id',
              component: UsersShow,
              name: 'users_show',
              breadcrumbs: 'Fiche d\'un utilisateur',
              meta: { requiresAuth: true }
          }
      ]
    },
    {
      path: '*',
      redirect: '/login'
    }
  ],
  scrollBehavior(to,from,savedPosition){
    // scroll to top or anchor #
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js